<template>
    <div :class="prefixCls">
        <div :class="`${prefixCls}-title`" @click="handleCollapse">
            <div :class="`${prefixCls}-title-content`">
                <slot name="title"></slot>
            </div>
            <span :class="`${prefixCls}-icon`">
                <Icon :type="isCollapse ? 'arrow-up' : 'arrow-down'"/>
            </span>
        </div>
        <CollapseTransition>
            <div :class="`${prefixCls}-content`" 
                v-show="isCollapse">
                <slot name="content"></slot>
            </div>
        </CollapseTransition>
    </div>
</template>
<script>
    import CollapseTransition from '../common/collapse-transition'
    import Icon from '../icon/'

    const prefixCls = 'yy-collapse'
    export default {
        name: 'YYCollapse',
        props: {
            defaultCollapse: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                isCollapse: this.defaultCollapse
            }
        },
        components: {
            CollapseTransition,
            Icon
        },
        methods: {
            handleCollapse() {
                this.isCollapse = !this.isCollapse
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base/collapse/collapse.vue